import { ActionsType } from '@tock/shared/utils/connect';
import { RevalidateCVV } from './RevalidateCVV';
import { core } from '@tock/coretypes';
import CreditCardDropdown from 'components/business/checkout/CreditCardDropdown';
import Field from '@tock/shared/components/forms/Field';

interface CCDetailsProps {
  actions: ActionsType;
  cards: core.PaymentCard[];
  cvcField: ReduxFormField<string>;
  isInitialized: boolean;
  isSubmitting: boolean;
  onRenderCreditCardForm(isSubmitting: boolean): JSX.Element;
  onSelectCard(storedPaymentCard: { value: string }): void;
  selectedCard?: core.PaymentCard;
  shouldRevalidateSavedCreditCards: boolean;
  shouldSaveCreditCard: boolean;
}

export const SelectCreditCardDetails: React.VFC<CCDetailsProps> = ({
  actions,
  cards,
  cvcField,
  isSubmitting,
  onRenderCreditCardForm,
  onSelectCard,
  selectedCard,
  shouldSaveCreditCard,
  shouldRevalidateSavedCreditCards,
  isInitialized,
}) => {
  return (
    <>
      {cards.length > 0 && shouldSaveCreditCard && (
        <div className="ConsumerCheckout-creditCardDropdown">
          <Field label="Select credit card" labelId="selectCreditCard">
            <CreditCardDropdown
              labelId="selectCreditCard"
              cards={cards}
              disabled={isSubmitting}
              selectedCard={selectedCard}
              onSelectCard={onSelectCard}
            />
          </Field>
          {selectedCard && shouldRevalidateSavedCreditCards && (
            <RevalidateCVV actions={actions} cvcField={cvcField} />
          )}
        </div>
      )}
      {isInitialized && !selectedCard && onRenderCreditCardForm(isSubmitting)}
    </>
  );
};
